import axios from 'axios';

// Create an axios instance
const axiosInstance = axios.create({
    baseURL: 'https://infrec.in/php-backend',
     headers: { "Content-Type": "application/json" },
  });

export default axiosInstance;